import { HttpClient } from "../HttpClient";
/**
 * * Put Content
 */
export const PutClaimant = async (content) => {
	try {
		const { data } = await HttpClient.put("api/contents/AssignClaimant", { ...content });
		return await Promise.resolve(data);
	} catch (err) {
		return Promise.reject(err);
	}
};
